import axios from '../utils/axios'

// 已登录新品预售
export function PresellApi (data) {
  return axios({
    url: '/Sale/Sale/Presell',
    method: 'post',
    data: data
  })
}

// 未登录新品预售
export function PresellNoLoginApi (data) {
  return axios({
    url: '/NoAuth/SaleIndex/PresellNoLogin',
    method: 'post',
    data: data
  })
}

// 是否开启新品预售
export function IsPresellApi () {
  return axios({
    url: '/NoAuth/SaleIndex/IsPresell',
    method: 'get'
  })
}

// 立即预定
export function PresellReserveAdd (data) {
  return axios({
    url: '/Sale/Sale/PresellReserveAdd',
    method: 'post',
    data: data
  })
}

// 取消预定
export function PresellReserveCancel (data) {
  return axios({
    url: '/Sale/Sale/PresellReserveCancel',
    method: 'post',
    data: data
  })
}
